module.exports = __webpack_public_path__ + "static/img/contact-bg.3e6d2b1d.jpg";